<ui-dialog size="small" [open]="isOpen" [isCloseable]="false" header="Error Posting Jobs">
    <p>
        We are only able to post {{ total - failed }} of {{ total }} {{ formattedJobPostingWord(total) }}. {{ failed }}
        {{ formattedJobPostingWord(failed) }} have conflicts in the job posting information that need to be resolved.
    </p>
    <ui-dialog-footer>
        <ui-button type="primary" (click)="confirm.emit()">Confirm</ui-button>
    </ui-dialog-footer>
</ui-dialog>
